import { render, staticRenderFns } from "./VisualizarSetorDialog.vue?vue&type=template&id=035d2cee"
import script from "./VisualizarSetorDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarSetorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports